import React from 'react'
import styled from 'styled-components'

import { breakpoint } from 'utils'

import {
  SectionElement,
  TextAndButtonWrapper,
  Title,
  ActionWrapper,
} from './Section.styles'

interface SectionProps {
  className?: string
  'data-testid'?: string
  title: React.ReactNode
  text?: React.ReactNode
  action?: React.ReactNode
}

const Section: React.FC<SectionProps> = props => {
  const {
    className,
    children,
    title,
    text,
    action,
    'data-testid': dataTestId,
  } = props

  return (
    <SectionElement className={className} data-testid={dataTestId}>
      <Title>{title}</Title>
      <TextAndButtonWrapper>
        {text}
        {action && <ActionWrapper>{action}</ActionWrapper>}
      </TextAndButtonWrapper>
      {children}
    </SectionElement>
  )
}

export default styled(Section)`
  & + & {
    margin-top: 40px;

    ${breakpoint('sm')`
      margin-top: 64px;
    `}
  }
`
